import React from 'react';
import Icon from '../../../components/AppIcon';


const SavedSearchPresets = ({ presets, onLoadPreset, onDeletePreset }) => {
  if (presets?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card border-b border-border p-4">
      <div className="flex items-center gap-2 mb-3">
        <Icon name="Bookmark" size={18} className="text-primary" />
        <h3 className="text-sm font-medium text-foreground">Gespeicherte Suchen</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {presets?.map((preset) => (
          <div
            key={preset?.id}
            className="flex items-center gap-2 px-3 py-1.5 bg-muted rounded-md hover:bg-muted/80 transition-colors group"
          >
            <button
              onClick={() => onLoadPreset(preset)}
              className="text-sm text-foreground hover:text-primary transition-colors"
            >
              {preset?.name}
            </button>
            <button
              onClick={() => onDeletePreset(preset?.id)}
              className="opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <Icon name="X" size={14} className="text-muted-foreground hover:text-destructive" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedSearchPresets;